import React, { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import { loadRemote } from '@module-federation/runtime';
import FullPageLoadingSplash from '@acorn-portal/shared/src/components/loading/FullPageLoadingSplash';

const HouseholdApp = React.lazy(() =>
	loadRemote('householdRemote/App').then((m) => {
		if (!m) throw new Error('Failed to load householdRemote/App');
		return m as { default: React.ComponentType };
	}),
);

const ErrorFallback: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
	<div style={{ padding: '2rem', textAlign: 'center' }} role='alert'>
		<h2>Something went wrong</h2>
		<p>This section is temporarily unavailable. Please try again.</p>
		<button onClick={onRetry} style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}>
			Retry
		</button>
		<p style={{ marginTop: '1rem' }}>
			<a href='/portal/home'>Go back to policies</a>
		</p>
	</div>
);

const PolicyProductGateway: React.FC = () => {
	const handleRetry = () => globalThis.location.reload();

	return (
		<Sentry.ErrorBoundary
			fallback={<ErrorFallback onRetry={handleRetry} />}
			beforeCapture={(scope) => {
				scope.setTag('product', 'household');
				scope.setTag('module_federation', 'true');
				scope.setContext('household_remote', {
					remoteEntry: import.meta.env.VITE_HOUSEHOLD_REMOTE_URL,
					exposedModule: './App',
				});
			}}
		>
			<Suspense fallback={<FullPageLoadingSplash message='Loading...' loading />}>
				<HouseholdApp />
			</Suspense>
		</Sentry.ErrorBoundary>
	);
};

export default PolicyProductGateway;
